// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#secondMoveBulkModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#secondMoveBulkModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#secondMoveBulkModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#secondMoveBulkModal .btn-link:focus {
  text-decoration: none;
}
#secondMoveBulkModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#secondMoveBulkModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
  #secondMoveBulkModal #confirmation-modal-label {
    font-size: 3.2rem;
  }
}
#secondMoveBulkModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
  #secondMoveBulkModal .invalid-feedback span {
    font-size: 1.84rem !important;
  }
}
@media (min-width: 2024px) {
  #secondMoveBulkModal .modal-dialog {
    max-width: 700px !important;
  }
}
@media (min-width: 2024px) {
  #secondMoveBulkModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
  }
}
@media (min-width: 2024px) {
  #secondMoveBulkModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
